import moment from "moment";

export function certnoGetInfo(certno) {
    var reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/; //验证身份证号的正则
    if (reg.test(certno)) { // 如果身份证号格式正确
        var perinfo = {};
        var orgBirthday = "";
        var orgGender = "";
        if (certno.length == 15) {
            orgBirthday = certno.substring(6, 12);
            orgGender = certno.substring(14, 15);
            perinfo.birth = "19" + orgBirthday.substring(0, 2) + "-"
                + orgBirthday.substring(2, 4) + "-"
                + orgGender.substring(4, 6);
            perinfo.gender = orgGender % 2 == 1 ? "male" : "female";
        } else if (certno.length == 18) {
            orgBirthday = certno.substring(6, 14);
            orgGender = certno.substring(16, 17);
            perinfo.birth = orgBirthday.substring(0, 4) + "-"
                + orgBirthday.substring(4, 6) + "-"
                + orgBirthday.substring(6, 8);
            perinfo.gender = orgGender % 2 == 1 ? "男" : "女";
        }
        return perinfo;  // 将生日和性别以对象的形式返回
    } else {
        return false;
    }
}

export function getRandomInt(min, max) {
    // 以下函数返回 min（包含）～ max（包含）之间的数字：
    return Math.floor(Math.random() * (max - min + 1)) + min
}

export function getCurrentDateTime() {
    return moment(new Date()).format('YYYYMMDDHHmmsss');
}